module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.3cf6adf.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Regular.woff
// module id = 454
// module chunks = 1